









import { defineComponent } from "@vue/composition-api";
import { NotificationSearchResult, Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import PageNotificationsView from "./components/PageNotificationsView";

export default defineComponent({
  name: "PageNotifications",
  components: { PageNotificationsView },
  setup() {
    const { authUserStrict } = useAuthUser();
    return { authUserStrict };
  },
  data() {
    return {
      loading: false,
      scroll: true,
      notificationsSearchResult: null as NotificationSearchResult | null,
    };
  },
  computed: {
    notificationsList(): Notification[] {
      return this.notificationsSearchResult?.result ?? [];
    },
  },
  methods: {
    async getNotifications(page = 0, replace = true) {
      try {
        this.scroll = false;
        const data = await providers.NotificationsProvider.find({
          data: {
            recipientId: this.authUserStrict.id,
            page,
            sort: "TIME,DESC",
          },
        });
        if (!replace && this.notificationsSearchResult) {
          data.result = [...this.notificationsSearchResult.result, ...data.result];
        }
        this.notificationsSearchResult = data;
      } finally {
        this.scroll = this.notificationsSearchResult?.hasNextPage ?? false;
      }
    },
    getNextData(cb?: Function) {
      const page = (this.notificationsSearchResult?.page ?? 0) + 1;
      this.getNotifications(page, false).finally(() => cb && cb());
    },
    async getPageData() {
      try {
        this.loading = true;
        await this.getNotifications();
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.getPageData();
  },
});
